import { render, staticRenderFns } from "./BVInput.vue?vue&type=template&id=7011f47f&scoped=true"
import script from "./BVInput.vue?vue&type=script&lang=js"
export * from "./BVInput.vue?vue&type=script&lang=js"
import style0 from "./BVInput.vue?vue&type=style&index=0&id=7011f47f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7011f47f",
  null
  
)

export default component.exports